<template>
  <v-menu bottom left :close-on-content-click="true">
    <template v-slot:activator="{ on }">
      <v-btn dark icon v-on="on">
        <v-icon>$vuetify.icons.rms_dot</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <div v-for="(menu,index) in menus" :key="index">
        <v-list-tile v-if="menu.allowed" :to="{name:menu.route}">
          <v-list-tile-avatar>
            <v-icon color="#FFA726">{{$vuetify.icons[menu.icon]}}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content class="text-center">
            <v-list-tile-title>{{menu.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Logout from "@/components/Logout";

export default {
  name: "DotsMenu",
  props: ["menus"],
  components: {
    Logout
  }
};
</script>
